import { useAppSelector } from "../store/hook";

// The logged-in admin's LoB region: which country principals belong to and
// whether India/eRupi-only inputs apply.
export const useLobRegion = () => useAppSelector((state) => state.lobConfig.region);
